// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ArrowLeftThick from '../_raw/ui/icon_arrow_left_thick.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ArrowLeftThick);
